import {
  ChangeDetectionStrategy,
  Component,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ReportOverlayDynamicService } from '@app/overlays/report-overlay/services/report-overlay-dynamic.service';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { Params } from '@angular/router';
import { RatingsComponent } from '../../../shared/components/ratings-component/ratings.component';
import { NgIf } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { AkitaRemoteConfigQuery } from '@app/akita/api/remote-config/state/remote-config.query';
import { logInAppReviewSubmitted } from '@app/core/services/google-analytics.lazy';
import { GoogleAnalyticsService } from '@app/core/services/google-analytics.service';

const MIN_RATING = 3;

/* const US_RATING_URL = 'https://g.page/r/CQg2YUVNw_0DEAg/review';
const BR_RATING_URL = 'https://g.page/popsy-app/review?rc'; */
export const GOOGLE_RATING_URL = 'https://g.page/r/CYqnNjETz4skEAI/review';
export const TRUSTPILOT_RATING_URL = 'https://bit.ly/popsy-trustpilot-web';

@Component({
  selector: 'app-rate-delivery-experience',
  templateUrl: './rate-delivery-experience.template.html',
  styleUrls: ['./rate-delivery-experience.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, NgIf, RatingsComponent],
})
export class RateDeliveryExperienceComponent implements OnChanges {
  @Input() public country?: string | null;
  @Input() public reportTitle?: string | null;
  @Input() public hideTitle?: boolean | null;
  @Input() public reportId?: string | null;
  @Input() public reportType?: 'checkout-success' | 'delivery-success' | null;
  @Input() public reportExtra?: Params | null;

  @Output() public readonly rated: EventEmitter<number>;

  public rating: number;
  public showFeedbackButton: boolean;
  public showRateUsButton: boolean;

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly reportOverlayDynamicService: ReportOverlayDynamicService,
    private readonly akitaRemoteConfigQuery: AkitaRemoteConfigQuery,
    private readonly analyticsService: GoogleAnalyticsService
  ) {
    this.rated = new EventEmitter();
    this.rating = 0;
    this.showFeedbackButton = false;
    this.showRateUsButton = false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.country) {
      this.changeDetector.markForCheck();
    }
  }

  public onRatingChange(rating: number): void {
    this.rating = rating;
    this.rated.next(this.rating);
    if (this.rating <= MIN_RATING) {
      this.showFeedbackButton = true;
      this.showRateUsButton = false;
    } else {
      this.showRateUsButton = true;
      this.showFeedbackButton = false;
    }
    this.changeDetector.markForCheck();
  }

  public onShowFeedback(): void {
    this.reportOverlayDynamicService.open({
      elementRef: null,
      data: {
        mode: this.reportType || '',
        id: this.reportId || '-',
        title: this.reportTitle || '',
        extra: {
          ...(this.reportExtra || {}),
          'Delivery Flow User Rating': `${this.rating || 1}`,
        },
        link: this.akitaRouterQuery.fragment,
        rtlMode: this.akitaRouterQuery.isRtlLanguage,
      },
      isBrowser: this.akitaRouterQuery.isBrowser,
    });
  }

  public onRatingClicked(): void {
    const sendTo = this.akitaRemoteConfigQuery.sendWebReviewsTo;
    let url = GOOGLE_RATING_URL;

    logInAppReviewSubmitted(
      this.analyticsService.logEventWrapper,
      sendTo || '',
      this.rating,
      'Order'
    );

    if (sendTo === 'TrustPilot') {
      url = TRUSTPILOT_RATING_URL;
    }

    try {
      (window as any).location.href = url;
    } catch (err) {}
  }
}
